import * as clack from '@clack/prompts'
import fs from 'node:fs'
import path from 'node:path'
import type { UpdateStylesCommandOptions } from '@cli-types/core-engine/commands.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export async function runUpdateStylesCommand(options: UpdateStylesCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  clack.intro('BetterStart Update Styles')

  const config = await resolveConfigOrExit(cwd)
  const adminDir = config.paths.admin
  const namespace = resolveAdminNamespace(config.frameworkConfig.next.namespace)
  const targetPath = path.join(cwd, adminDir, namespace.globalsFile)

  if (!fs.existsSync(targetPath)) {
    clack.cancel(`${namespace.globalsFile} not found at ${path.relative(cwd, targetPath)}`)
    process.exit(1)
  }

  fs.writeFileSync(
    targetPath,
    applyAdminNamespaceToContent(readTemplate('admin-globals.css'), namespace.segment),
    'utf-8'
  )

  clack.log.success(`Updated ${path.relative(cwd, targetPath)}`)
  clack.outro('Styles updated')
}
